export default function videoThumbLazy(lazyVideos = []) {
    if (!("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const wrapper = entry.target;
            const video = wrapper.querySelector("video");
            if (!video) return;

            const sources = video.querySelectorAll("source[data-src]");
            const thumb = wrapper.querySelector(".video-thumb");

            wrapper.classList.add("loading");
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.setAttribute("muted", "");
            video.setAttribute("loop", "");
            video.setAttribute("playsinline", "");

            // Lazy load video sources
            sources.forEach((src) => (src.src = src.dataset.src));
            video.load();

            const revealVideo = () => {
                wrapper.classList.remove("lazy", "loading");
                if (thumb) thumb.classList.add("hidden");
            };

            video.addEventListener("loadeddata", () => {
                revealVideo();
                video.play().catch(() => {});
            });

            video.addEventListener("play", revealVideo);

            // Stop observing after load
            obs.unobserve(wrapper);
        });
    });

    lazyVideos.forEach((el) => observer.observe(el));
}
